import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import { forwardRef } from "react";
import { typographyClassName } from "@creditornot/cb-ingredients";
import "./style.css";
const SvgDrawerOpen = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M23.876 11.263l-3.07-5.5a1.956 1.956 0 00-1.7-1.009H4.9a1.955 1.955 0 00-1.7 1.005L.13 11.263a1.382 1.382 0 00-.13.487v6a1.5 1.5 0 001.5 1.5h21a1.5 1.5 0 001.5-1.5v-6a1.218 1.218 0 00-.124-.487zM4.83 6.879a.248.248 0 01.218-.129l13.865-.016a.248.248 0 01.218.128l2.241 4.016a.25.25 0 01-.218.372H17.5a1.491 1.491 0 00-1.061.439A1.51 1.51 0 0016 12.75a1.5 1.5 0 01-1.5 1.5h-5a1.5 1.5 0 01-1.5-1.5 1.5 1.5 0 00-1.5-1.5H2.844a.251.251 0 01-.219-.371z" }) }));
const SvgCommonFileDash = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M3 4a1 1 0 01-1-1V2a2 2 0 012-2h1.5a1 1 0 010 2H4v1a1 1 0 01-1 1zM5.5 22a1 1 0 010 2H4a2 2 0 01-2-2v-1a1 1 0 012 0v1zM20 24h-1.5a1 1 0 010-2H20v-1a1 1 0 012 0v1a2 2 0 01-2 2zM17 3a1 1 0 01-.707-.293L15.586 2H14.5a1 1 0 010-2h1.086A2.015 2.015 0 0117 .586l.707.707A1 1 0 0117 3zM3 9a1 1 0 01-1-1V6.5a1 1 0 012 0V8a1 1 0 01-1 1zM10.75 2h-1.5a1 1 0 010-2h1.5a1 1 0 010 2zM10.5 24H9a1 1 0 010-2h1.5a1 1 0 010 2zM15 24h-1.5a1 1 0 010-2H15a1 1 0 010 2zM3 13.5a1 1 0 01-1-1V11a1 1 0 012 0v1.5a1 1 0 01-1 1zM3 18.5a1 1 0 01-1-1V16a1 1 0 012 0v1.5a1 1 0 01-1 1zM21 9a1 1 0 01-1-1V6.914l-.707-.707a1 1 0 011.414-1.414l.707.707A1.986 1.986 0 0122 6.914V8a1 1 0 01-1 1zM21 13.5a1 1 0 01-1-1V11a1 1 0 012 0v1.5a1 1 0 01-1 1zM21 18.5a1 1 0 01-1-1V16a1 1 0 012 0v1.5a1 1 0 01-1 1z" }) }));
const SvgCommonFileEmpty = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M22 6.328V22a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h11.672a2 2 0 011.414.586l4.328 4.328A2 2 0 0122 6.328z" }) })
);
const SvgCommonFileText = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M21.414 4.914L17.086.586A2 2 0 0015.672 0H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.328a2 2 0 00-.586-1.414zM11 19.5H6.5a1 1 0 010-2H11a1 1 0 010 2zm4.5-4h-9a1 1 0 010-2h9a1 1 0 010 2zm0-4h-9a1 1 0 010-2h9a1 1 0 010 2z" }) }));
const SvgFolderOpen = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M23.44 9.549A1.492 1.492 0 0022.28 9H10.42a.5.5 0 01-.491-.4l-.278-1.395A1.5 1.5 0 008.18 6H1.72A1.5 1.5 0 00.249 7.8l2.6 13A1.5 1.5 0 004.32 22h15.961a1.5 1.5 0 001.47-1.2l2-10a1.5 1.5 0 00-.311-1.251zM3.22 5a1 1 0 00.98-.778A.263.263 0 014.443 4H19.72a.5.5 0 01.5.5V7a1 1 0 002 0V4a2 2 0 00-2-2h-16a2 2 0 00-2 2 1 1 0 001 1z" }) }));
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_EmptyIcon_Root_r1xj",
  propsAsIs: false
});
const Folder = (props) => /* @__PURE__ */ jsx(Root$1, {
  ...props,
  children: /* @__PURE__ */ jsx(SvgFolderOpen, {})
});
const Drawer = (props) => /* @__PURE__ */ jsx(Root$1, {
  ...props,
  children: /* @__PURE__ */ jsx(SvgDrawerOpen, {})
});
const FileDash = (props) => /* @__PURE__ */ jsx(Root$1, {
  ...props,
  children: /* @__PURE__ */ jsx(SvgCommonFileDash, {})
});
const FileText = (props) => /* @__PURE__ */ jsx(Root$1, {
  ...props,
  children: /* @__PURE__ */ jsx(SvgCommonFileText, {})
});
const FileEmpty = (props) => /* @__PURE__ */ jsx(Root$1, {
  ...props,
  children: /* @__PURE__ */ jsx(SvgCommonFileEmpty, {})
});
const EmptyIcon = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Drawer,
  FileDash,
  FileEmpty,
  FileText,
  Folder
}, Symbol.toStringTag, { value: "Module" }));
const Root = /* @__PURE__ */ styled("span")({
  name: "Root",
  class: "cb_Empty_Root_r1k2",
  propsAsIs: false
});
const Title = /* @__PURE__ */ styled("div")({
  name: "Title",
  class: "cb_Empty_Title_t3ej",
  propsAsIs: false
});
const Description = /* @__PURE__ */ styled("div")({
  name: "Description",
  class: "cb_Empty_Description_dnv0",
  propsAsIs: false
});
const Content = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_Empty_Content_c1v3",
  propsAsIs: false
});
const Footer = /* @__PURE__ */ styled("div")({
  name: "Footer",
  class: "cb_Empty_Footer_fzcx",
  propsAsIs: false
});
const ImageContainer = /* @__PURE__ */ styled("div")({
  name: "ImageContainer",
  class: "cb_Empty_ImageContainer_i1an",
  propsAsIs: false
});
const Empty = ({
  className,
  description,
  footer,
  image = /* @__PURE__ */ jsx(Folder, {}),
  style,
  title
}) => /* @__PURE__ */ jsxs(Root, {
  className,
  style,
  children: [/* @__PURE__ */ jsx(ImageContainer, {
    children: image
  }), !!(title || description) && /* @__PURE__ */ jsxs(Content, {
    children: [!!title && /* @__PURE__ */ jsx(Title, {
      className: typographyClassName.Title1,
      children: title
    }), !!description && /* @__PURE__ */ jsx(Description, {
      className: typographyClassName.Body3,
      children: description
    })]
  }), !!footer && /* @__PURE__ */ jsx(Footer, {
    children: footer
  })]
});
const Empty$1 = Empty;
export {
  Empty$1 as Empty,
  EmptyIcon
};
//# sourceMappingURL=index.js.map
